import React from "react";

const stats = [
  { label: "Clients Worldwide", value: "500+" },
  { label: "Team Members", value: "100+" },
  { label: "Countries", value: "25+" },
  { label: "Success Rate", value: "98%" },
];

const StatsSection = () => {
  return (
    <div className="row g-4 py-4 py-lg-5">
      {stats.map((stat, index) => {
        const valueNumber = stat.value.slice(0, -1);
        const valueSuffix = stat.value.slice(-1);
        return (
          <div key={index} className="col-md-3 col-6 mt-lg-0">
            <div className="aboutUsstatCard px-3 py-2">
              <h4 className="display-4 text-black font_500">
                {valueNumber}
                <span className="text_master2">{valueSuffix}</span>
              </h4>
              <p className="text_light1 mb-0">{stat.label}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatsSection;
